import React, { useState } from "react";
import {
    IconButton,
    Menu,
    MenuItem
} from "@mui/material";
import { ReactComponent as DeleteIcon } from './../../assets/Icons/Delete.svg';
import MoreVertIcon from '@mui/icons-material/MoreVert';
interface MyFundsMenuProps {

}
export const MyFundsMenu: React.FC<
    MyFundsMenuProps
> = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                onClick={handleClick}
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}>
                <MoreVertIcon sx={{ color: 'neutral.light' }} />
            </IconButton>
            {anchorEl && (
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    sx={{
                        "& .MuiMenu-paper": { px: 1 },
                    }}
                >

                    <MenuItem
                        className="contribution-dropdown"
                    >
                        <DeleteIcon /> Cease to be advisor
                    </MenuItem>
                </Menu>
            )}

        </>
    );
};
